import { render, staticRenderFns } from "./NoProductPage.vue?vue&type=template&id=0d3161ed&scoped=true&"
import script from "./NoProductPage.vue?vue&type=script&lang=js&"
export * from "./NoProductPage.vue?vue&type=script&lang=js&"
import style0 from "./NoProductPage.vue?vue&type=style&index=0&id=0d3161ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3161ed",
  null
  
)

export default component.exports